import NotificationHandler from "../utils/NotificationHandler";
import isNull from "../utils/NullChecking";

export default function Open_Patient_Tab(state = [], action) {
    
    if (action.type === 'Open_Patient_Tab') {
        let arrayList; let arrayObject;

        if (action.payload.data) {
            arrayObject = action.payload.data;

            // check if we have data in data object
            if (arrayObject.length === 0) {
                arrayList = []
            } else {

                if (isNull(action.payload.id)) {
                    let initiallData = [...state]
                    // let BOOL= false
                    // initiallData.map((item) => {
                    //     if(item.active === true){
                    //         console.log(item);
                    //         if(item.data.id === -1){
                    //             arrayList = [...action.payload.data]
                    //             BOOL = true
                    //         }
                    //     }
                    // })
                    // if(BOOL === true){
                    //     return arrayList
                    // }else {
                        let isTabExist = [...state].filter((tab) => {
                            return tab.key === arrayObject.key && tab.data.id === arrayObject.data.id
                        })
                        if (!(isTabExist && isTabExist.length > 0)) {
                            if (state.length === 6) {
                                NotificationHandler('Sorry! You can add maximum 5', 'success')
                                arrayList = [...state]
                            } else {
                                arrayObject.active = true
                                initiallData.forEach((row) => (row.active = false))
                                arrayList = [...state, arrayObject]
                            }
                        } else {
                            initiallData.forEach((row, index) => {
                                if (arrayObject.data.id === row.data.id) {
                                    row.active = true
                                    arrayObject.Open_Encounter_Tab = initiallData[index].Open_Encounter_Tab
                                    initiallData[index] = arrayObject;
                                } else {
                                    row.active = false
                                }
                            })
                            arrayList = initiallData
                        }
                    // }
                    
                } else {
                    let updatedArray = [...state].filter((items) => items.data.id !== action.payload.id)
                    let arrayLength = updatedArray.length;
                    if (arrayLength > 0) {
                        updatedArray[arrayLength - 1].active = true
                    }

                    arrayList = updatedArray
                }
            }
            return arrayList

        } else {
            return []
        }
    }else if (action.type === 'Open_New_Patient_Tab'){
    if(action.payload.data){
        return action.payload.data
    }else{
        return []
    }
    }

    // New action to handle encounter tabs inside a patient tab
    else if (action.type === 'Open_Encounter_Tab') {
        const { patientId, tab } = action.payload;
        if (!patientId || !tab) return state;
      
        return state.map(patient => {
          if (patient.data.id !== patientId) return patient;
      
          let existingTabs = Array.isArray(patient.Open_Encounter_Tab) ? [...patient.Open_Encounter_Tab] : [];
      
          // Check if this tab already exists
          const tabExists = existingTabs.some(t => t.key === tab.key && t.data.id === tab.data.id);
      
          if (!tabExists) {
            // Enforce max tabs limit
            if (existingTabs.length >= 6) {
              NotificationHandler('Sorry! You can add maximum 5 encounter tabs per patient', 'error');
              // No change, just return original patient
              return patient;
            }
            // Deactivate all existing tabs
            existingTabs = existingTabs.map(t => ({ ...t, active: false }));
            // Add new tab as active
            if (tab.data.id === 0) {
                /// To put All Encounter at first index
                existingTabs = [{ ...tab, active: true }, ...existingTabs];
            } else {
                existingTabs.push({ ...tab, active: true });
            }
          } else {
            // Activate the existing tab and deactivate others
            existingTabs = existingTabs.map(t => {
              if (t.key === tab.key && t.data.id === tab.data.id) {
                return { ...t, active: true };
              }
              return { ...t, active: false };
            });
          }
      
          return {
            ...patient,
            Open_Encounter_Tab: existingTabs
          };
        });
    }
    else if (action.type === 'Open_New_Encounter_Tab'){
        const { patientId, encounterId, newObj } = action.payload;
    
        return state.map(patient => {
            if (patient.data.id !== patientId) return patient;
    
            const updatedTabs = (patient.Open_Encounter_Tab || []).map(tab => {
                if (tab.data.id === encounterId) {
                    return { ...newObj, active: true }; // Replace existing tab
                }
                return tab;
            });
    
            return {
                ...patient,
                Open_Encounter_Tab: updatedTabs
            };
        });
    }else if (action.type === 'Clear_Add_Encounter_Popup') {
    const { patientId, encounterId } = action.payload;

    return state.map(patient => {
        if (patient.data.id !== patientId) return patient;

        const updated = (patient.Open_Encounter_Tab || []).map(tab => {
            if (tab.data.id !== encounterId) return tab;

            return {
                ...tab,
                data: {
                    ...tab.data,
                    AddEncounterPopup: null
                }
            };
        });

        return {
            ...patient,
            Open_Encounter_Tab: updated
        };
    });
    }
    else if (action.type === 'OPEN_PATIENT_WITH_ENCOUNTER_TAB') {
        const { patientTab, encounterTab } = action.payload;
        const existingPatientIndex = state.findIndex(p => p.data.id === patientTab.data.id);
        let updatedState = [...state];

        // If patient doesn't exist, add it
        if (existingPatientIndex === -1) {
            const newPatient = {
                ...patientTab,
                active: true,
                Open_Encounter_Tab: [{ ...encounterTab, active: true }]
            };

            // Deactivate other patient tabs
            updatedState = updatedState.map(p => ({ ...p, active: false }));

            if (updatedState.length >= 5) {
                NotificationHandler('Sorry! You can add maximum 5 patients', 'error');
                return state;
            }

            return [...updatedState, newPatient];
        }

        // If patient exists
        updatedState = updatedState.map((patient, index) => {
            if (index === existingPatientIndex) {
                const updatedEncounterTabs = Array.isArray(patient.Open_Encounter_Tab)
                    ? [...patient.Open_Encounter_Tab]
                    : [];

            const encounterExists = updatedEncounterTabs.some(
                tab => tab.key === encounterTab.key && tab.data.id === encounterTab.data.id
            );

            // Update encounter tabs
            let newEncounters;
            if (!encounterExists) {
                if (updatedEncounterTabs.length >= 6) {
                    NotificationHandler('Sorry! You can add maximum 5 encounter tabs per patient', 'error');
                    return { ...patient }; // No change
                }
                newEncounters = updatedEncounterTabs.map(t => ({ ...t, active: false }));
                if (encounterTab.data.id === 0) {
                    newEncounters = [{ ...encounterTab, active: true }, ...newEncounters];
                } else {
                    newEncounters.push({ ...encounterTab, active: true });
                }
            } else {
                newEncounters = updatedEncounterTabs.map(tab =>
                    tab.key === encounterTab.key && tab.data.id === encounterTab.data.id
                        ? { ...tab, active: true, data: { ...tab.data, AddEncounterPopup: encounterTab?.data?.AddEncounterPopup } }

                        : { ...tab, active: false }
                );
            }

            return {
                ...patient,
                active: true,
                Open_Encounter_Tab: newEncounters
            };
        }

        return {
            ...patient,
            active: false
        };
    });

    return updatedState;
    }
    else if (action.type === 'Close_Encounter_Tab') {
        const { patientId, encounterId } = action.payload;

        return state.map(patient => {
            if (patient.data.id !== patientId) return patient;

            const updated = (patient.Open_Encounter_Tab || []).filter(tab => tab.data.id !== encounterId);

            if (updated.length > 0) {
                updated[updated.length - 1].active = true;
            }

            return {
                ...patient,
                Open_Encounter_Tab: updated
            };
        });
    }

    return state;
}